import { Component, OnInit, ViewChild } from '@angular/core';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { default as UserListGridCol } from './user-list-gridColumns.json';
import { GridService } from 'app/Shared/Services/grid.service';
import { DataService } from 'app/Shared/Services/data.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { WhitespaceValidator } from 'app/Shared/Constant/whitespaces-validator';
import { ConfirmPasswordValidator } from 'app/Shared/Constant/confirm-password.validator';
import { HttpErrorResponse } from '@angular/common/http';
import { ButtonModule } from 'primeng/button';
import { Table, TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { AddUserComponent } from '../add-user/add-user.component';
import { LowerCasePipe, NgClass, CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DrawerModule } from 'primeng/drawer';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AuthServiceService } from 'app/Authentification/auth-service.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
  imports: [ButtonModule, TableModule, DialogModule, AddUserComponent,
    DrawerModule, CommonModule, MatTooltipModule, LowerCasePipe,
    ConfirmDialogModule, MatProgressSpinnerModule, NgClass, FormsModule]
})
export class UserListComponent implements OnInit {
  @ViewChild(('dt')) dt!: Table;
  userListGridCols: any;
  userListDataset: any = [];
  data: any;
  totalRecords!: number;
  userListGridColumns: any;
  defaultFilterArray: any;
  isLoadingResults: boolean = true;
  cols: any = [];
  filterCols: any = [];
  edit!: boolean;
  rowDataforDialog: any;
  rowIndexForDialog!: number;
  View!: boolean;
  displayDialog: boolean = false;
  selectedUser: any;


  constructor(private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private userService: UserService,
    public constantService: ConstantService,
    private gridService: GridService,
    public dataService: DataService,
    public confirmationService: ConfirmationService,
    private messageService: MessageService,
    private authServiceService: AuthServiceService,
    private formBuilder: FormBuilder) {

  }

  ngOnInit() {
    this.defaultFilterArray = [
      {
        "isdefault": "true",
        "label": "Date",
        "columnname": "l.Created_Date",
        "filterby": "IS",
        "values": [
          new Date(),
          new Date()
        ],
        "time": "",
        "datatype": "DateRange",
        "disabled": "true",
        "dropdown": "",
        "dropdownvalue": ""
      }

    ];
    this.totalRecords = this.constantService.DEFAULT_ROWSIZE;
    this.getColumns();
    this.getData();
  }

  getColumns() {
    let column: any;
    column = UserListGridCol;
    if (column !== null || column !== undefined) {
      this.cols = this.gridService.getGridColumns(column);
      this.filterCols = this.cols;
    }
  }

  closeEditDialog() {
    this.selectedUser = null;
    this.edit = false;
    this.displayDialog = false;
    this.View = false;
  }

  closeDialog(event: any) {
    this.closeEditDialog();
    if (event) {
      this.getData();
    }
  }

  getBooleanValue(value: any) {
    let booleanString = "";
    if (value == 1 || value == 'true')
      booleanString = 'True'
    if (value == 0 || value == 'false')
      booleanString = 'False'
    return booleanString;
  }

  onRowSelect(value: any, index: any, rowData: any) {
    if (value == 'View') {
      this.selectedUser = (rowData);
      this.View = true;
    }
    if (value == 'edit') {
      this.edit = true;
      this.selectedUser = (rowData);
      this.edit = true;
    }
  }


  getData() {
    this.isLoadingResults = true;
    let payload = {
      mpid: this.userService.getActiveMPID(),
      data: this.defaultFilterArray
    }
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.userList
      ), payload)
      .subscribe({
        next: (res: any) => {
          this.isLoadingResults = false;
          this.userListDataset = res.data;
          this.totalRecords = this.userListDataset.length;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);


        }, error: (err: HttpErrorResponse) => {
          this.isLoadingResults = false;
        }
      });
  }

  FilterApplyFilterEvent(event: any) {
    this.defaultFilterArray = [];
    this.defaultFilterArray = event;
    this.getData();
  }


  onDelete(rowData: any) {
    this.selectedUser = rowData;
    let email = rowData?.emailId;
    this.confirmationService.confirm({
      message: 'Are you sure you want to permanently delete this user? This action cannot be undone.',
      key: 'userEditConfirmationDialog',
      acceptLabel: 'Ok',
      acceptIcon: 'pi pi-check',
      rejectLabel: 'No',
      rejectIcon: 'pi pi-times',
      acceptButtonStyleClass: "confirm-dialog-button",
      rejectButtonStyleClass: "confirm-dialog-button",
      accept: () => {

        let payload: any = {
          username: email
        }
        this.isLoadingResults = true;
        this.authServiceService.mfa_deleteUser(
          payload
        ).subscribe({
          next: (res: any) => {
            if (res?.status) {

              this.sharedHttpClientService.post(
                this.urlsService.setAPIURl(
                  APIURL.deleteUserData
                ), payload)
                .subscribe({
                  next: (res: any) => {
                    this.isLoadingResults = false;
                    if (res?.status) {
                      this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: res?.message || 'User Deleted successfully'
                      });
                      this.getData();
                      this.userService.logUserActivity("Admin - Delete User Details ", null, {
                        'Text1': 'Deleted User Details:' + email,
                        'Text2': 'Payload: ' + JSON.stringify(payload)
                      });
                    } else {
                      this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to delete user details'
                      });
                      this.userService.logUserActivity("Rsms - delete User Details ", null, {
                        'Text1': 'Something went wrong.',
                        'Text2': 'Payload: ' + JSON.stringify({ payload })
                      });
                    }
                  }, error: (err: HttpErrorResponse) => {
                    this.isLoadingResults = false;
                  }
                });

            } else {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to delete user details'
              });
              this.userService.logUserActivity("Cognito - delete User Details ", null, {
                'Text1': 'Something went wrong.',
                'Text2': 'Payload: ' + JSON.stringify({ payload })
              });
            }
          },
          error: (err: HttpErrorResponse) => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to delete user details'
            });
            this.userService.logUserActivity("Cognito - delete User Details ", null, {
              'Text1': 'Failed Error Occured :' + err?.error?.message,
              'Text2': 'Payload: ' + JSON.stringify({ payload })
            });
          }
        });
      }
    });
  }

}
